import { useRef, useState } from "react";
import type { QuickLoginController } from "./useQuickLogin";

export interface PinEnrolmentOptions {
  quickLogin: QuickLoginController | null;
  onSuccess(): void | Promise<void>;
  onEnrolFailed(): void;
}

export function usePinEnrolment({
  quickLogin,
  onSuccess,
  onEnrolFailed,
}: PinEnrolmentOptions) {
  const [pending, setPending] = useState(false);
  const finishing = useRef(false);

  const offer = async (): Promise<boolean> => {
    return (await quickLogin?.afterPasswordLogin()) ?? false;
  };

  const claim = () => {
    if (!quickLogin || finishing.current) return null;
    finishing.current = true;
    setPending(true);
    return quickLogin;
  };

  const land = async () => {
    try {
      await onSuccess();
    } catch (error) {
      finishing.current = false;
      setPending(false);
      throw error;
    }
  };

  return {
    pending,
    offer,
    skip: async () => {
      if (claim()) await land();
    },
    enrol: async (pin: string) => {
      const controller = claim();
      if (!controller) return;
      const saved = await controller.enrol(pin).catch(() => false);
      if (!saved) onEnrolFailed();
      await land();
    },
  };
}
